import React from "react";

/**
 * Top brand logo — composite "mammoth·love" wordmark + mammoth coach figure
 * baked into a single PNG. Responsive: scales fluidly across devices.
 *
 * Props:
 *  - width: number (px) or CSS string (e.g. "clamp(120px, 14vw, 200px)")
 *  - className: forwarded
 */
export const BrandLogo = ({ width = "clamp(160px, 18vw, 260px)", className = "", style = {} }) => {
  const w = typeof width === "number" ? `${width}px` : width;
  return (
    <img
      src="/mammoth_track.png"
      alt="mammoth-track"
      draggable={false}
      style={{
        width: w,
        height: "auto",
        display: "block",
        userSelect: "none",
        ...style,
      }}
      className={className}
    />
  );
};

export default BrandLogo;
